import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getBorder, getBorderRadius } from 'Components/utils';
import NotActivePicker
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault/RightSide/ScenariosPicker/Scenarios/Scenario/NotActivePicker';
import WhatIfClientScenarioDetails from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';

const styles = (theme) => ({
  root: {
    position: 'relative',
    ...getBorder(theme, {
      all: true, width: 2, borderStyle: 'dashed', color: theme.palette.grey[200],
    }),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  scenarioContainer: {
    height: 800,
    overflowX: 'hidden',
    overflowY: 'scroll',
    overscrollBehavior: 'contain',
    width: 400,
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  text: {
    paddingBottom: theme.spacing(2),
  },
});

const Scenario = ({
  className,
  classes,
  scenarioResource,
}) => {
  const { pageContentCollection } = usePageContentContext();
  const [facetPlanClientViewResource] = scenarioResource.attr('scenario');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <VerticalStack>
        <StackItem paddingTop={2}>
          <Text
            className={classes.text}
            text={scenarioResource.attr('label')}
            variant={'h5'}
            weight={'bold'}
          />
        </StackItem>
        <StackItem fillsSpace padding={2}>
          <Paper
            className={classes.scenarioContainer}
            variant={'tight'}
          >
            <NotActivePicker
              resource={scenarioResource}
            />
            <WhatIfClientScenarioDetails
              rounded
              facetPlanClientViewCollection={pageContentCollection}
              facetPlanClientViewResource={facetPlanClientViewResource}
              isProposalPreview
            />
          </Paper>
        </StackItem>
      </VerticalStack>
    </Box>
  );
};

Scenario.defaultProps = {
  className: '',
};

Scenario.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  scenarioResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Scenario);
